<template>
  <footer class="app-footer">
    <span><a href="https://leaf.ai">leaf analytics, llc</a> &copy; {{ year }}</span>
  </footer>
</template>
<script>
export default {
  name: 'c-footer',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
